<template>
    <div class="ppv2-my-3 ppv2-space-y-3">
        <div
            v-for="(metric, index) in filteredMetrics"
            :key="index"
            class="ppv2-flex ppv2-items-center ppv2-justify-between ppv2-border !ppv2-border-black !ppv2-border-opacity-20 ppv2-rounded-xl ppv2-shadow-none"
            :style="{ padding: normalizeSize(16, true) }"
        >
            <div class="ppv2-flex ppv2-items-center" :style="{ gap: normalizeSize(16, true) }">
                <div class="text-purple">
                    <component :is="metric.icon" :size="20" />
                </div>
                <span class="ppv2-text-black poppinsRegular" :style="{ fontSize: normalizeFontSize(15) }">{{
                    metric.label
                }}</span>
            </div>
            <span class="ppv2-text-black poppinsSemiBold" :style="{ fontSize: normalizeFontSize(15) }">{{ metric.value }}</span>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'
import normalizeFontSize from '../../../utils/normalizeFontSize'
export default {
    name: 'MetricsList',
    props: {
        metrics: {
            type: Array,
            required: true,
            // Expected format: [{ label: String, value: String|Number, icon: Component }]
        },
    },
    computed: {
        filteredMetrics() {
            return this.metrics.filter((metric) => metric.value != 0)
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>

<style scoped lang="scss">
.poppinsMedium {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
}
.poppinsBold {
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
}
</style>
